import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import NoTicketsImg from 'src/assets/no-tickets.svg';
import EmptyState from 'src/components/ui/EmptyState/EmptyState';
import PageHeader from 'src/components/ui/PageHeader/PageHeader';
import TicketItem from 'src/components/ui/TicketItem/TicketItem';
import TicketMap from 'src/components/ui/TicketMap/TicketMap';
import { routes } from 'src/routes';
import {
  getPriorityTickets,
  setTicketList,
} from 'src/store/actions/ticketActions';
import { useLoadingSelector } from 'src/utils/useLoadingSelector';

import classes from './ServiceHome.module.scss';

const ServiceHome: FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const priorityTickets = useAppSelector(
    (state) => state.ticket.priorityTickets
  );
  const loading = useLoadingSelector({
    actionType: getPriorityTickets.toString(),
  });

  useEffect(() => {
    dispatch(setTicketList({ count: 0, data: [], ctx: null }));
    dispatch(getPriorityTickets());
    return () => {
      dispatch(setTicketList({ count: 0, data: [], ctx: null }));
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className={classes.Container}>
      <PageHeader title={t('common:dashboard')} className={classes.Header} />
      <section>
        <h4>{t('dashboard:map_overview')}</h4>
        <TicketMap />
      </section>
      <section>
        <h4>{`${t('common:to_do')} ${t('common:tickets').toLowerCase()}`}</h4>
        <div>
          {!loading &&
            priorityTickets?.map((ticket, i) => (
              <TicketItem ticket={ticket} key={i} />
            ))}
          {loading &&
            [...Array(3)].map((_, i) => <TicketItem loading key={i} />)}
        </div>
        {!priorityTickets?.length && !loading ? (
          <EmptyState
            title={t('dashboard:no_tickets')}
            subtitle={t('dashboard:no_tickets_details')}
            icon={NoTicketsImg}
          />
        ) : (
          <Link to={routes.TICKETS}>{t('dashboard:view_all_tickets')}</Link>
        )}
      </section>
    </div>
  );
};

export default ServiceHome;
